import React from "react"
import styled from "styled-components/macro"
import PageLayout from "../components/PageLayout"
import { PageMargin } from "../GlobalStyles"
import HomeInitCta from "../components/HomePage/HomeInitCta/HomeInitCta"
import HomeIntroContent from "../components/HomePage/HomeIntroContent/HomeIntroContent"
import HomeServiceLinks from "../components/HomePage/HomeIntroContent/HomeServiceLinks"
import HomeTestimonials from "../components/HomePage/HomeTestimonials/HomeTestimonials"
import HomeContact from "../components/HomePage/HomeContact/HomeContact"
import useTestimonialConditional from "../hooks/useTestimonialConditional.ts"

const bgImgUrl = (width, height, gravity) =>
  `https://res.cloudinary.com/agoraservices/g_${gravity},c_fill,w_${width},h_${height},q_auto,f_auto/Priority%20Health%20Facilities//General%20Images/iStock-1134451603_jis7ng.jpg`

const Banner = styled.div`
  width: 100%;
  background-image: url(${bgImgUrl(550, 350, "faces:center")});
  height: 350px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right center;
  @media screen and (min-width: 550px) {
    background-image: url(${bgImgUrl(790, 550, "faces:center")});
    height: 450px;
    background-position: right bottom;
  }
  @media screen and (min-width: 790px) {
    background-image: url(${bgImgUrl(1024, 650, "faces:center")});
    height: 450px;
    background-position: right center;
  }
  @media screen and (min-width: 1024px) {
    background-image: url(${bgImgUrl(1500, 750, "auto")});
    height: 550px;
    background-position: center top;
  }
  @media screen and (min-width: 1500px) {
    background-image: url(${bgImgUrl(1920, 1000, "auto")});
    height: 700px;
    background-position: center -50px;
  }
`

export default function Home() {
  const hasTestimonials = useTestimonialConditional()

  return (
    <PageLayout currLocation="/">
      <Banner />
      <PageMargin>
        <HomeInitCta />
        <HomeIntroContent />
        <HomeServiceLinks />
        {hasTestimonials && <HomeTestimonials />}
        <HomeContact />
      </PageMargin>
    </PageLayout>
  )
}
